import { Component, OnInit } from "@angular/core";
import { FacadeService } from "../../../service/facade.service";
import {
  ScrollToService,
  ScrollToConfigOptions
} from "@nicky-lenaers/ngx-scroll-to";
import { tap } from "rxjs/operators";

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"]
})
export class BannerComponent implements OnInit {
  banners = [];
  scrollDir = 0;
  currentHeight = 400;

  constructor(
    private facadeService: FacadeService,
    private scrollToService: ScrollToService
  ) {}

  ngOnInit() {
    this.facadeService.Product.slider
      .pipe(
        tap(res => {
          const newResData: Array<any> = [];

          for (let banner of res.data) {
            let newBanner = { ...banner, show: false, loading: true };
            newResData.push(newBanner);
          }
          res.data = newResData;
        })
      )
      .subscribe(res => {
        this.banners = res.data;
      });
    this.onScrolling();
  }

  // on window scroll event
  onScrolling() {
    window.addEventListener("scroll", e => {
      // get current Image by windows scroll
      let currentIndex = ((window.scrollY + 300) / 760).toFixed(0);
      // save effected element first time

      // reset effected element
      if (this.scrollDir < window.scrollY) {
        this.scrollDown(currentIndex);
      } else {
        this.scrollUp(currentIndex);
      }

      this.scrollDir = window.scrollY;
    });
  }

  // window is  scroll to Down

  scrollDown(currentIndex) {
    // get elment after current elemnet
    let elementAfter: any = document
      .getElementsByClassName("image")
      .item(+currentIndex - 1);
    //element not null
    if (!elementAfter) return;
    // get incrased value
    let incraceValue = (((window.scrollY * 1.1) / 760) * 50) / currentIndex;
    // restet to zero
    if (incraceValue > 100) {
      incraceValue = 0;
    }
    // set anmition style
    elementAfter.style.transform = `translate3d(0px,  ${incraceValue}px , 0px)`;
    elementAfter.children[0].children[1].style.top = `  ${70}% `;
  }

  // window is scroll to up
  scrollUp(currentIndex) {
    // get  elment before current element
    let elementBefore: any = document
      .getElementsByClassName("image")
      .item(currentIndex);
    //element not null
    if (!elementBefore) return;
    // // resetset anmition style
    elementBefore.style.transform = `translate3d(0px, 0px , 0px)`;
    elementBefore.children[0].children[1].style.top = `50%`;
  }
  /**
   *
   * @param index
   */
  triggerScrollTo(index: number) {
    const check =
      this.banners.length < index
        ? this.banners.find((index, value) => !!value[index])
        : index + 1;
    const config: ScrollToConfigOptions = {
      target: check
    };
    this.scrollToService.scrollTo(config);
  }

  onload(index: number) {
    this.banners[index].loading = false;
  }
}
